import { MAP_TYPES } from '@deck.gl/carto';

const HISTORICALHIGHCOLLISION_RAMP_SOURCE_ID = 'historicalHighCollisionRampSource';

const source = {
  id: HISTORICALHIGHCOLLISION_RAMP_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'hccl_ramp_source',
};

export default source;
